export const DEFAULT_COUNTRY = 'us'
